import { render, staticRenderFns } from "./input.vue?vue&type=template&id=1c57d9e4&scoped=true&lang=pug&"
import script from "./input.vue?vue&type=script&lang=js&"
export * from "./input.vue?vue&type=script&lang=js&"
import style0 from "./input.vue?vue&type=style&index=0&id=1c57d9e4&prod&lang=scss&scoped=true&"
import style1 from "./input.vue?vue&type=style&index=1&id=1c57d9e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c57d9e4",
  null
  
)

/* custom blocks */
import block0 from "~/lang/formFields?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fubuntu%2Fnuxt%2Fbonkers%2Freleases%2F20230602131631%2Fcomponents%2Fwidgets%2Ffilters%2Finput.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsFormsInput: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/forms/input.vue').default,WidgetsFiltersFilter: require('/home/ubuntu/nuxt/bonkers/releases/20230602131631/components/widgets/filters/filter.vue').default})
